import entityTypes from '@/utils/entityTypes'
import { toDictionary } from '@/utils/array'

export default class SearchResult {
    constructor(data) {
        Object.assign(this, data)
    }

    get link() {
        return entityTypes.getLink(this.type, this.id)
    }

    static fromArray(data) {
        return data?.map(item => new SearchResult(item))
    }

    static fromGrouped(data) {
        const result = { ...data }

        result.companies ??= { results: [], meta: { resultCount: 0 } }

        result.executives ??= { results: [], meta: { resultCount: 0 } }

        result.interviews ??= { results: [], meta: { resultCount: 0 } }

        const interviews = result.interviews.results

        if (interviews.length > 0) {
            const executives = toDictionary(
                [...result.executives.results.map(e => e.entity), ...(data.related?.executives ?? [])],
                e => e.id
            )
            interviews.forEach(i => (i.entity.executive = executives[i.entity.executiveId]))
        }

        if (result.related) {
            delete result.related
        }

        return result
    }
}
